import { memo, useState } from 'react';

import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { IconArrowDown06 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  title?: string;
  titleColor?: string;
  noticeList?: string[];
  noticeColor?: string;
  /** true 시 자동 불릿(·) 없이 작성한 그대로 노출 */
  hideBullet?: boolean;
  onNoticeToggle?: (active: boolean) => void;
}

const ToggleNotice = ({
  title = '유의사항',
  titleColor = '#777',
  noticeList,
  noticeColor = '#777',
  hideBullet = false,
  onNoticeToggle,
}: IProps) => {
  const [active, setActive] = useState(false);
  const cName = classNameBind([
    'event-notice',
    active === true ? 'active' : '',
  ]);

  return (
    <S.ToggleNotice
      className={cName}
      $titleColor={titleColor}
      $noticeColor={noticeColor}
      $hideBullet={hideBullet}
    >
      <Button
        onClick={() => {
          setActive(!active);
          onNoticeToggle?.(!active);
        }}
      >
        {title}
        <IconArrowDown06 />
      </Button>
      {active === true && (
        <div className="notice-wrap">
          {noticeList?.map((v, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Text key={i} block>
              {v}
            </Text>
          ))}
        </div>
      )}
    </S.ToggleNotice>
  );
};

export default memo(ToggleNotice);
